import * as React from "react"
import {
  AudioWaveform,
  BookOpen,
  Bot,
  Command,
  Frame,
  GalleryVerticalEnd,
  Map,
  PieChart,
  Settings2,
  SquareTerminal,
  Store,
  Package,
  Users,
  BarChart3,
  ShoppingCart,
  FileText,
  ClipboardList,
} from "lucide-react"

import { NavMain } from "@/components/nav-main"
import { NavProjects } from "@/components/nav-projects"
import { NavUser } from "@/components/nav-user"
import { TeamSwitcher } from "@/components/team-switcher"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
} from "@/components/ui/sidebar"
import { useAuth } from "@/contexts/AuthContext"

// This is sample data.
const data = {
  user: {
    name: "Admin User",
    email: "admin@bazariadigital.id",
    avatar: "/avatars/shadcn.jpg",
  },
  teams: [
    {
      name: "Bazaria Digital",
      logo: GalleryVerticalEnd,
      plan: "Digital UMKM",
    },
    // {
    //   name: "Store Management",
    //   logo: Store,
    //   plan: "Pro",
    // },
  ],
  navMain: [
    {
      title: "Dashboard",
      url: "/admin",
      icon: BarChart3,
    },
    {
      title: "Product Management",
      url: "/admin/products",
      icon: Package,
    },
    {
      title: "Order Management",
      url: "/admin/orders",
      icon: ClipboardList,
    },
    {
      title: "Sell Requests",
      url: "/admin/sell-requests",
      icon: ShoppingCart,
    },
    {
      title: "Store Management",
      url: "/admin/stores",
      icon: Store,
    },
    {
      title: "Reports",
      url: "#",
      icon: FileText,
      items: [
        {
          title: "Sales Report",
          url: "#",
        },
        {
          title: "Product Analytics",
          url: "#",
        },
        {
          title: "Store Performance",
          url: "#",
        },
      ],
    },
  ],
  projects: [
    {
      name: "Quick Actions",
      url: "#",
      icon: Frame,
    },
    {
      name: "Bulk Operations",
      url: "#",
      icon: PieChart,
    },
    {
      name: "Data Export",
      url: "#",
      icon: Map,
    },
  ],
}

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const { user, userProfile, userRole } = useAuth()

  // Update user data based on actual auth
  const userData = {
    name: userProfile?.display_name || "Mr.Unknown",
    email: user?.email || "Email not set",
    avatar: "/avatars/shadcn.jpg",
  }

  // Filter nav items based on user role
  const filteredNavMain = data.navMain.filter(item => {
    if (item.title === "Store Management" && userRole !== "superadmin") {
      return false
    }
    return true
  })

  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader>
        <TeamSwitcher teams={data.teams} />
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={filteredNavMain} />
        <NavProjects projects={data.projects} />
      </SidebarContent>
      <SidebarFooter>
        <NavUser user={userData} />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  )
}
